import { useMutation, useQueryClient } from "@tanstack/react-query"

import { updateCriteriaGroup } from "../../services/criteriaGroup";
import { IIndicators } from "../../types/indicator";
import { toast } from "react-toastify";

const useUpdateCriteriaGroup = (indicator: IIndicators) => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: updateCriteriaGroup,
        onMutate: () => {
            indicator.setIsProcessRunning(true);
            indicator.setIsServiceError(null);
        },
        onSuccess: (statusCode) => {
            if (statusCode === 200) {
                queryClient.invalidateQueries({ queryKey: ["criteria-groups"] });
                indicator.setIsProcessRunning(false);
                indicator.setIsServiceError(null);
                toast.success("Criteria group updated successfully")
            }
        },
        onError: (error: any) => {
            indicator.setIsServiceError(error?.response?.data?.message);
            indicator.setIsProcessRunning(false);
            toast.error(error?.response?.data?.message);
        }
    })
}

export default useUpdateCriteriaGroup;